import { ProductTogSwitcherInfoInterface } from '@qlevr/shared/interfaces';
import { Maybe, MetafieldShopify, MetaobjectShopify } from '@qlevr/shared/schema';
import { getMetafieldReferencesImageField } from './get-metafield-references-image-field';
import { getMetafieldsByKey } from './get-metafields-by-key';

export function getTogInfoReferenceFields(
  title: string,
  references: Maybe<MetafieldShopify>[],
): ProductTogSwitcherInfoInterface | null {
  const reference = references.find((item) => item?.key === title)?.reference;

  if (!reference || reference.__typename !== 'Metaobject') {
    return null;
  }

  const metaobject = reference as MetaobjectShopify;
  const extractedTitle = getMetafieldsByKey('title', metaobject.fields) || null;
  const text_before_image = getMetafieldsByKey('text_before_image', metaobject.fields) || null;
  const text_after_image = getMetafieldsByKey('text_after_image', metaobject.fields) || null;
  const images = getMetafieldReferencesImageField('images', metaobject.fields);

  return {
    title: extractedTitle,
    images,
    text_before_image,
    text_after_image,
  };
}
